module.exports = __webpack_public_path__ + "static/media/big-small.5d724206.jpeg";